var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProductDesign(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 16,
    fill: "#3C609C"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_643_16193)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.6665 12.6667L13.7999 9.79999C13.4988 9.50036 13.0913 9.33215 12.6665 9.33215C12.2418 9.33215 11.8343 9.50036 11.5332 9.79999L9.79987 11.5333C9.50024 11.8344 9.33203 12.2419 9.33203 12.6667C9.33203 13.0914 9.50024 13.4989 9.79987 13.8L12.6665 16.6667",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.333 12L14.6663 10.6666",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 18.6667L21.3333 17.3334",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.333 15.3334L22.1997 18.2C22.8263 18.8267 22.8263 19.84 22.1997 20.4667L20.4663 22.2C19.8397 22.8267 18.8263 22.8267 18.1997 22.2L15.333 19.3334",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.1156 12.5414C22.4681 12.189 22.6662 11.711 22.6662 11.2126C22.6663 10.7142 22.4683 10.2362 22.116 9.88372C21.7636 9.53124 21.2856 9.33319 20.7872 9.33313C20.2888 9.33307 19.8108 9.531 19.4583 9.88338L10.561 18.7827C10.4062 18.9371 10.2917 19.1271 10.2276 19.3361L9.34696 22.2374C9.32973 22.295 9.32843 22.3563 9.3432 22.4146C9.35796 22.473 9.38824 22.5262 9.43083 22.5687C9.47341 22.6112 9.52671 22.6414 9.58507 22.6561C9.64343 22.6708 9.70467 22.6694 9.7623 22.6521L12.6643 21.7721C12.8731 21.7086 13.0631 21.5948 13.2176 21.4407L22.1156 12.5414Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18 11.3334L20.6667 14",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_643_16193"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(8 8)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProductDesign);
export default __webpack_public_path__ + "static/media/product_design.ac6aa2aa4896a27a0f30cf5c4ca19f45.svg";
export { ForwardRef as ReactComponent };